export class DayScheduleInfo {
  dayRange: string;
  sequence: number;
  workingTime: Array <any>;
  canBeGrouppedWithNext: boolean;

  constructor(
    dayRange: string,
    sequence: number,
    workingTime: Array <any>,
    canBeGrouppedWithNext: boolean,
  ) {
    this.dayRange = dayRange;
    this.sequence = sequence;
    this.workingTime = workingTime;
    this.canBeGrouppedWithNext = canBeGrouppedWithNext;
  }

  static arrayFromJSON(json: string): DayScheduleInfo {
    const value = JSON.parse(json);
    if (!value) {
      return null;
    }

    let result: DayScheduleInfo = null;
    result = DayScheduleInfo.createFromAny(value);

    return result;
  }

  static createFromAny(object: any): DayScheduleInfo {
    if (object === null || object === undefined) {
      return null;
    }

    return new DayScheduleInfo(
      object.dayRange,
      object.sequence,
      object.workingTime,
      object.canBeGrouppedWithNext,
    );
  }
}
